export const FAQ_DATA = [
    {
        id: 1,
        question: "Can I share my trips with other people?",
        answer: "Yes! You can invite friends to your trip by clicking the 'Share' button in your trip dashboard. They can view and edit the itinerary with you!"
    },
    {
        id: 2,
        question: "Will my trip information be disclosed to anyone?",
        answer: "No. Your privacy is our priority. Your trip details are private to you and the people you explicitly share them with."
    },
    {
        id: 3,
        question: "How much does it cost to use TravelBuddy?",
        answer: "TravelBuddy is currently free to use! We may introduce premium features in the future, but the core planning tools will remain free."
    },
    {
        id: 4,
        question: "Will my information be stored anymore if I deleted my account?",
        answer: "No. Your information will be completely deleted from the system once you choose to delete your TravelBuddy account. Making a new account will require you to create all information again."
    },
    {
        id: 5,
        question: "I have a problem/feedback that I want to raise. Where do I go to?",
        answer: ({ onEnquiryClick }) => (
            <>
                <p>If you have any questions or concerns, please don't hesitate to contact us:</p>
                <ul style={{ listStyle: 'none', padding: 0, marginTop: '10px' }}>
                    <li><strong>•</strong> <strong style={{ paddingLeft: '5px' }}>Email:</strong> info@thetravelbuddy.com.au</li>
                    <li><strong>•</strong> <strong style={{ paddingLeft: '5px' }}>Phone:</strong> 0402420062</li>
                </ul>
                <p style={{ marginTop: '10px' }}>Or simply submit a form by clicking <a href="#" style={{ color: '#359de5' }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); onEnquiryClick(); }}>here</a>.</p>
            </>
        )
    }
];